<template>
  <div class="container-exibicao" @click="$refs.input.focus()">
    <span class="exibicao">
      <b>{{ campo.name }}:</b>
      <input
        ref="input"
        type="text"
        v-mask="mascaraData"
        :placeholder="placeholder"
        :value="text"
        @input="aoDigitar"
        @change="aoConcluirEdicao"
        @keyup.enter="aoConfirmar"
      />
      <SVGIcon v-if="!campo.default" iconName="icon-close" :size="8" @click.stop="aoExcluir" />
    </span>
    <span ref="textSizer" class="text-sizer">{{ text }}</span>
  </div>
</template>
<script>
import SVGIcon from '../../SvgIcon.vue';

const FORMATO_DATA = 'DD/MM/YYYY';

export default {
  name: 'InputDateUnica',
  emits: ['update:text', 'dateCleared', 'dateBlanked', 'dateSelected'],
  components: {
    SVGIcon
  },
  props: {
    campo: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      datePicker: null,
      placeholder: '00/00/0000',
      mascaraData: '##/##/####'
    };
  },
  watch: {
    text(novoValor) {
      const instancia = this.datePicker ? this.datePicker.data('daterangepicker') : null;
      if (!instancia) return;

      if (!novoValor) {
        $(this.$refs.input).val('');
        this.ajustaLarguraInput();
        return;
      }

      const dataMoment = moment(novoValor, FORMATO_DATA, true);
      if (!dataMoment.isValid()) return;

      instancia.setStartDate(dataMoment);
      instancia.setEndDate(dataMoment);
      $(this.$refs.input).val(dataMoment.format(FORMATO_DATA));
      this.ajustaLarguraInput();
    }
  },
  mounted() {
    this.iniciaDatePicker();
    this.ajustaLarguraInput();
  },
  beforeUnmount() {
    if (this.datePicker) {
      this.datePicker.remove();
    }
  },
  methods: {
    aoDigitar(evento) {
      this.$emit('update:text', evento.target.value);
      this.ajustaLarguraInput();
    },
    aoConcluirEdicao(evento) {
      if (evento.target.value) return;

      this.$emit('update:text', '');
      this.$emit('dateBlanked');
      this.ajustaLarguraInput();
    },
    aoExcluir() {
      $(this.$refs.input).val('');
      const instancia = this.datePicker ? this.datePicker.data('daterangepicker') : null;
      if (instancia) instancia.remove();
      this.$emit('update:text', '');
      this.$emit('dateCleared');
      this.ajustaLarguraInput();
    },
    iniciaDatePicker() {
      if (typeof $ === 'undefined' || !$.fn.daterangepicker) {
        console.warn('DateRangePicker não está disponível');
        return;
      }

      const opcoes = {
        singleDatePicker: true,
        autoApply: true,
        showDropdowns: true,
        autoUpdateInput: false,
        opens: 'right',
        locale: {
          format: FORMATO_DATA,
          applyLabel: 'Aplicar',
          cancelLabel: 'Limpar',
          daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sa'],
          monthNames: [
            'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
            'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
          ]
        }
      };

      const dataInicial = moment(this.text, FORMATO_DATA, true);
      if (dataInicial.isValid()) {
        opcoes.startDate = dataInicial;
        opcoes.endDate = dataInicial;
        $(this.$refs.input).val(dataInicial.format(FORMATO_DATA));
      }

      this.datePicker = $(this.$refs.input).daterangepicker(opcoes);

      $(this.$refs.input).on('apply.daterangepicker', (evento, picker) => {
        const valorFormatado = picker.startDate.format(FORMATO_DATA);
        $(this.$refs.input).val(valorFormatado);
        this.$emit('update:text', valorFormatado);
        this.$emit('dateSelected', valorFormatado);
        this.ajustaLarguraInput();
      });

      $(this.$refs.input).on('cancel.daterangepicker', () => {
        $(this.$refs.input).val('');
        this.$emit('update:text', '');
        this.$emit('dateCleared');
        this.ajustaLarguraInput();
      });

      this.adicionaClasseCustomizada();
    },
    adicionaClasseCustomizada() {
      $('.daterangepicker').addClass('custom-daterangepicker');
    },
    ajustaLarguraInput() {
      const input = this.$refs.input;
      const textSizer = this.$refs.textSizer;
      if (!input || !textSizer) return;

      textSizer.textContent = input.value || this.placeholder;
      input.style.width = `${textSizer.offsetWidth + 5}px`;
    },
    aoConfirmar() {
      const dataMoment = moment(this.text, FORMATO_DATA, true);
      if (!dataMoment.isValid()) return;

      this.$emit('dateSelected', dataMoment.format(FORMATO_DATA));
    }
  }
};
</script>
